import DesignTokens from '@tableau/design-tokens';
import { ClearBaseIcon } from '@tableau/icons/ClearBaseIcon';
import { SearchBaseIcon } from '@tableau/icons/SearchBaseIcon';
import { ButtonType, ButtonWidget, InteractionState } from '@tableau/widgets';
import React from 'react';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { PageHeaderStyles } from '~src/spacesPlatform/components/layout/PageHeaderStyles';
import { applyColor } from '~src/style/ColorService';

import { HeaderSearchBox } from '../header/HeaderSearchBox';
import cssVar = PageHeaderStyles.CssVariables.cssVar;
import CssVariables = PageHeaderStyles.CssVariables;

export const vizHeaderSearchButtonImgTestId = 'viz-header-search-button-img';

export interface SearchProps {
  headerSearchStyle: string;
  searchClosed: (event: BaseJQueryEventObject) => void;
  searchClosedWithoutNeedingFocus: (event: BaseJQueryEventObject) => void;
  letSearchBoxHasFocus?: boolean;
  isSearchInputBoxActive: (isActive: boolean) => void;
}

export function PageHeaderSearch(props: SearchProps): JSX.Element {
  return (
    <div className={props.headerSearchStyle}>
      <HeaderSearchBox
        omniboxOpenWidth={350}
        searchClosed={props.searchClosed}
        searchClosedWithoutNeedingFocus={props.searchClosedWithoutNeedingFocus}
        isSearchOpen={true}
        letSearchBoxHasFocus={props.letSearchBoxHasFocus}
        isSearchInputBoxActive={props.isSearchInputBoxActive}
      />
    </div>
  );
}

interface IconInfo {
  width: number;
  height: number;
}

function buttonIconInfo(): IconInfo {
  return {
    width: 32,
    height: 32
  };
}

const getButtonContent = (isSearchOpen: boolean): (state: InteractionState) => JSX.Element => {
  return (state: InteractionState): JSX.Element => {
    const showActiveIcon = state.hover || state.active || state.focus;
    const iconInfo = buttonIconInfo();
    let iconStyle: React.CSSProperties = { width: iconInfo.width, height: iconInfo.height, marginRight: '0px' };
    const wrappingDivHoverStyle = { backgroundColor: state.hover ? cssVar(CssVariables.headerBackgroundHoverColor) : 'transparent' };

    const isCloseIcon = isSearchOpen;

    // Keep alt text blank since button has a title: TFS 1036309
    return (
      <div style={{ ...CommonStyles.Layout.FlexBlockLeftAndCenter, ...wrappingDivHoverStyle }}>
        {isCloseIcon ? (
          <span
            style={{ ...iconStyle, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            data-tb-test-id={vizHeaderSearchButtonImgTestId}
          >
            <ClearBaseIcon
              size={18}
              color={showActiveIcon
                ? applyColor(DesignTokens.color.icon.default.default, '#333333')
                : applyColor(DesignTokens.color.icon.default.default, '#666666')}
              alt=""
            />
          </span>
        ) : (
          <span
            style={{ ...iconStyle, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            data-tb-test-id={vizHeaderSearchButtonImgTestId}
          >
            <SearchBaseIcon
              size={20}
              color={showActiveIcon
                ? applyColor(DesignTokens.color.icon.default.default, '#333333')
                : applyColor(DesignTokens.color.icon.default.default, '#666666')}
              alt=""
            />
          </span>
        )}
      </div>
    );
  };
};

export interface VizViewerSearchButtonProps {
  readonly isSearchOpen: boolean;
  readonly title: string;
  readonly testId: string;
  readonly onClick: () => void;
  readonly setRef: (button: ButtonWidget) => void;
}

export function VizViewerSearchButton(props: VizViewerSearchButtonProps): JSX.Element {
  return (
    <div style={{ lineHeight: 0, marginRight: '-2px' }}>
      <ButtonWidget
        buttonType={ButtonType.IconOutline}
        getContent={getButtonContent(props.isSearchOpen)}
        title={props.title}
        testId={props.testId}
        handleClick={props.onClick}
        ref={props.setRef}
        style={{ cursor: 'pointer' }}
      />
    </div>
  );
}
